import { z } from 'zod'
import type { Role } from '../constants/roles'

export const RoleSchema = z.enum([
  'ADMIN',
  'GENERAL_DIRECTOR',
  'MANAGER',
  'PROCUREMENT',
  'ROP',
  'ROS',
  'ASSISTANT',
  // Роли этапа 3 (с 23.09.2026) — см. constants/roles.ts.
  'ACCOUNTANT',
  'LOGIST',
  'WAREHOUSE_HEAD',
  'WAREHOUSE_QC',
  'WAREHOUSE_KEEPER',
])

// Legacy alias
export const UserRoleSchema = RoleSchema

export const UserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  role: RoleSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type User = z.infer<typeof UserSchema>

export const JwtPayloadSchema = z.object({
  sub: z.string().uuid(),
  email: z.string().email(),
  role: RoleSchema,
  iat: z.number().optional(),
  exp: z.number().optional(),
})

export type JwtPayload = z.infer<typeof JwtPayloadSchema>

export interface AuthUser {
  id: string
  email: string
  role: Role
  name?: string | null
  personalEmail?: string | null
  /** Телефон менеджера (из профиля) — подставляется в строку «Телефон» КП. */
  phone?: string | null
  gridSettings?: Record<string, unknown> | null
  /** Только для роли ASSISTANT: менеджеры, к которым прикреплён помощник (из /auth/me). */
  assistantManagers?: { id: string; name: string | null; email: string }[]
  /**
   * Города пользователя (из /auth/me). Пустой массив = «все города».
   * Нужны интерфейсу, чтобы показывать, в каком срезе человек сейчас работает
   * (шапка «Очереди квот»): раньше отфильтрованный по городу список выглядел
   * так же, как полный, и понять причину «где мои позиции» было нельзя.
   */
  cities?: string[]
  /**
   * Момент входа в аккаунт (мс эпохи). Кладётся в токен при входе и переносится
   * при обновлении токена: по нему объявления «каждый вход в аккаунт» понимают,
   * закрыл ли человек их в этом входе. У токенов старого формата поля нет.
   */
  loginAt?: number
}
